import { Component, Input } from '@angular/core';

@Component({
  selector: 'tur-additional-info-area',
  templateUrl: './additional-info-area.component.html',
  styleUrls: ['./additional-info-area.component.scss'],
})
export class AdditionalInfoAreaComponent {
  @Input() public additionalInfo: string;
  @Input() public beInfos: string;
  @Input() public uiInfos: string;
}
